import { UPDATE_AGENT } from '../../endpoints';
import { IAgent } from '../../types/agent';
import makeAuthenticatedRequest from '../base-api';

interface UpdateAgentResponse {
  success: boolean;
  message?: string;
  agent?: IAgent;
}

const updateAgentApi = async (
  payload: IAgent
): Promise<UpdateAgentResponse> => {
  try {
    const response = await makeAuthenticatedRequest(UPDATE_AGENT, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Update agent failed:', error);
    throw error;
  }
};

export { updateAgentApi, type UpdateAgentResponse };
